module.exports = __webpack_public_path__ + "static/media/revanth.fa327fb8.png";